import { render, staticRenderFns } from "./ExercisesCarouselHistory.vue?vue&type=template&id=7bdc7863&scoped=true"
import script from "./ExercisesCarouselHistory.vue?vue&type=script&lang=js"
export * from "./ExercisesCarouselHistory.vue?vue&type=script&lang=js"
import style0 from "./ExercisesCarouselHistory.vue?vue&type=style&index=0&id=7bdc7863&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdc7863",
  null
  
)

export default component.exports